import axiosInsAcademy from '@/api/axios-ugems-academy';

export default {
  // Get all attendance reports
  getAttendanceReports(params) {
    return axiosInsAcademy.get('/attendance/report', { params });
  },

  // Get attendance report detail
  getAttendanceReportDetail(id) {
    return axiosInsAcademy.get(`/attendance/report/${id}`);
  },

  // Get attendance report schedules
  getAttendanceSchedules(id) {
    return axiosInsAcademy.get(`/attendance/report/${id}/schedules`);
  },

  // Get schedule employees attendance
  getScheduleEmployees(id, params) {
    return axiosInsAcademy.get(`/attendance/report/schedule/${id}/employees`, { params });
  },

  // Download schedule report
  downloadScheduleReport(scheduleId) {
    return axiosInsAcademy.get(`/attendance/report/schedule/${scheduleId}/download`, {
      responseType: 'blob'
    });
  },

  // Download attendance report
  downloadReport(trainingEventId) {
    return axiosInsAcademy.get(`/attendance/report/${trainingEventId}/download`, {
      responseType: 'blob'
    });
  },

  // Download all attendance reports
  downloadAllReports(params) {
    return axiosInsAcademy.get('/attendance/reports/download-all', {
      params,
      responseType: 'blob'
    });
  }
};
